import { Button, ButtonProps, createPolymorphicComponent } from '@mantine/core';
import React from 'react';

export type IBasicButtonProps = Omit<ButtonProps, 'component'> &
  Omit<React.ComponentPropsWithoutRef<'button'>, keyof ButtonProps | 'ref'> & {
    children?: React.ReactNode;
  };

const BasicButtonBase = React.forwardRef<HTMLButtonElement, IBasicButtonProps>(
  ({ children, type = 'button', ...props }, ref) => (
    <Button
      {...props}
      ref={ref}
      type={type}
      disabled={props.disabled || props.loading}
    >
      {children}
    </Button>
  ),
);
BasicButtonBase.displayName = 'BasicButton';

/** @registry Base Mantine Button wrapper (auto-disables while loading); forwards its ref and is polymorphic via `component`; the default building block every other button in src/design/atoms composes. */
export const BasicButton = createPolymorphicComponent<
  'button',
  IBasicButtonProps
>(BasicButtonBase);
